import React from 'react';
import PropTypes from 'prop-types';
import { Menu, Accordion } from 'semantic-ui-react';
import AccordionTitle from './accordionTitle';
import AccordionContent from './accordionContent';

const accordionMenu = props => {
  return (
    <Accordion as={Menu} inverted>
      <Menu.Item>
        <AccordionTitle
          activeIndex={props.activeIndex}
          index={props.index}
          handleClick={props.handleClick}
          title={props.title}
          icon={props.icon}
          dropdownStyle={props.dropdownStyle}
        />
        <AccordionContent
          activeIndex={props.activeIndex}
          index={props.index}
          menu={props.menu}
          handleClickConfirm={props.handleClickConfirm}
          handleClick={props.handleClick}
          activeIndexLevel2={props.activeIndexLevel2}
          handleClickLevel2={props.handleClickLevel2}
        />
      </Menu.Item>
    </Accordion>
  );
};

// const accordionMenu = props => (
//   <Accordion as={Menu} inverted>
//     <Menu.Item>
//       <AccordionTitle
//         activeIndex={props.activeIndex}
//         index={props.index}
//         handleClick={props.handleClick}
//         title={props.title}
//         icon={props.icon}
//         dropdownStyle={props.dropdownStyle}
//       />
//       <AccordionContent
//         activeIndex={props.activeIndex}
//         index={props.index}
//         menu={props.menu}
//         handleClickConfirm={props.handleClickConfirm}
//       />
//     </Menu.Item>
//   </Accordion>
// );

accordionMenu.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  icon: PropTypes.string,
  menu: PropTypes.array,
  dropdownStyle: PropTypes.object,
  handleClickConfirm: PropTypes.func,
  activeIndexLevel2: PropTypes.number,
  handleClickLevel2: PropTypes.func,
};
export default accordionMenu;
